var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"points":"17.812,11.107 12.893,11.107 12.893,6.187 11.107,6.187 11.107,11.107 6.187,11.107 6.187,12.893 11.107,12.893 \n\t11.107,17.812 12.893,17.812 12.893,12.893 17.812,12.893 "}})}
var staticRenderFns = []

export { render, staticRenderFns }